module.exports = __webpack_public_path__ + "console/img/万象.2c473948.jpg";